import React from 'react';
import PropTypes from 'prop-types';

const Cancel = props => {
  const { color, width, height, ...other } = props;

  return (
    <svg width={width} height={height} viewBox="0 0 24 24" version="1.1" xmlns="http://www.w3.org/2000/svg" {...other}>
      <g id="cancel" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <polygon id="Shape" points="0 0 24 0 24 24 0 24"></polygon>
        <path d="M12,10.5734975 L17.2780592,5.29543834 C17.671977,4.90152055 18.3106439,4.90152055 18.7045617,5.29543834 C19.0984794,5.68935612 19.0984794,6.32802304 18.7045617,6.72194082 L13.4265025,12 L18.7045617,17.2780592 C19.0984794,17.671977 19.0984794,18.3106439 18.7045617,18.7045617 C18.3106439,19.0984794 17.671977,19.0984794 17.2780592,18.7045617 L12,13.4265025 L6.72194082,18.7045617 C6.32802304,19.0984794 5.68935612,19.0984794 5.29543834,18.7045617 C4.90152055,18.3106439 4.90152055,17.671977 5.29543834,17.2780592 L10.5734975,12 L5.29543834,6.72194082 C4.90152055,6.32802304 4.90152055,5.68935612 5.29543834,5.29543834 C5.68935612,4.90152055 6.32802304,4.90152055 6.72194082,5.29543834 L12,10.5734975 Z" id="Combined-Shape" fill={color} fillRule="nonzero"></path>
      </g>
    </svg>
  );
}

Cancel.propTypes = {
  color: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number,
};

Cancel.defaultProps = {
  color: '#000000',
  width: 24,
  height: 24,
};

export default Cancel;



// WEBPACK FOOTER //
// ./src/components/Icons/Cancel.jsx